<template>
  <strong
    v-if="column.property === 'OverallProductivityPercentage'"
    :style="{ color: ProductivityColor }"
  >
    {{ rowValue.toFixed(2) }} %
  </strong>
  <strong v-else :style="{ color: NoProductivityColor }">
    {{ rowValue > 0 ? rowValue.toFixed(2) : 0 }}
  </strong>
</template>

<script>
export default {
  name: "ColorsForProductivityAndNonProductivity",
  props: {
    rowValue: {
      type: Number,
      default: 0,
      required: true
    },
    row: {
      type: Object,
      default: () => ({}),
      required: true
    },
    column: {
      type: Object,
      default: () => ({}),
      required: true
    },
    call: {
      type: Function,
      default: () => {},
      required: true
    }
  },
  data() {
    return {};
  },
  computed: {
    ProductivityColor() {
      if (this.rowValue >= 90) {
        return "green";
      } else if (this.rowValue >= 80) {
        return "orange";
      } else {
        return "red";
      }
    },
    NoProductivityColor() {
      if (this.rowValue <= 0) {
        return "green";
      } else {
        return "red";
      }
    }
  },
  methods: {}
};
</script>
